import { IconProps } from 'types/icon.type'

export const LogoutIcon = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Logout icon</title>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 3.75C5.16848 3.75 4.85054 3.8817 4.61612 4.11612C4.3817 4.35054 4.25 4.66848 4.25 5V19C4.25 19.3315 4.3817 19.6495 4.61612 19.8839C4.85054 20.1183 5.16848 20.25 5.5 20.25H9.5C9.91421 20.25 10.25 20.5858 10.25 21C10.25 21.4142 9.91421 21.75 9.5 21.75H5.5C4.77065 21.75 4.07118 21.4603 3.55546 20.9445C3.03973 20.4288 2.75 19.7293 2.75 19V5C2.75 4.27065 3.03973 3.57118 3.55546 3.05546C4.07118 2.53973 4.77065 2.25 5.5 2.25H9.5C9.91421 2.25 10.25 2.58579 10.25 3C10.25 3.41421 9.91421 3.75 9.5 3.75H5.5ZM15.9697 6.46967C16.2626 6.17678 16.7374 6.17678 17.0303 6.46967L22.0303 11.4697C22.3232 11.7626 22.3232 12.2374 22.0303 12.5303L17.0303 17.5303C16.7374 17.8232 16.2626 17.8232 15.9697 17.5303C15.6768 17.2374 15.6768 16.7626 15.9697 16.4697L19.6893 12.75H9.5C9.08579 12.75 8.75 12.4142 8.75 12C8.75 11.5858 9.08579 11.25 9.5 11.25H19.6893L15.9697 7.53033C15.6768 7.23744 15.6768 6.76256 15.9697 6.46967Z"
        fill="currentColor"
      />
    </svg>
  )
}
